import { render, staticRenderFns } from "./tradenewslist.vue?vue&type=template&id=aa678ed0&scoped=true&"
import script from "./tradenewslist.vue?vue&type=script&lang=js&"
export * from "./tradenewslist.vue?vue&type=script&lang=js&"
import style0 from "./tradenewslist.vue?vue&type=style&index=0&id=aa678ed0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa678ed0",
  null
  
)

export default component.exports